import { render } from "./ModalAddIncluirPep.vue?vue&type=template&id=803c66fa"
import script from "./ModalAddIncluirPep.vue?vue&type=script&lang=js"
export * from "./ModalAddIncluirPep.vue?vue&type=script&lang=js"

import "./ModalAddIncluirPep.vue?vue&type=style&index=0&id=803c66fa&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__